import { IHICustomer, IHICustomerDetails } from '../interfaces/IHealthInsurance'

export const SET_HI_CUSTOMER = 'SET_HI_CUSTOMER'
export const RESET_HI_CUSTOMER = 'RESET_HI_CUSTOMER'
export const SET_HI_CUSTOMER_DETAILS = 'SET_HI_CUSTOMER_DETAILS'

interface ISetHICustomer {
  type: typeof SET_HI_CUSTOMER
  payload: {
    customerData: IHICustomer
  }
}

interface ISetHICustomerDetails {
  type: typeof SET_HI_CUSTOMER_DETAILS
  payload: {
    customerData: IHICustomerDetails
  }
}

interface IResetHICustomer {
  type: typeof RESET_HI_CUSTOMER
}

export type TActionTypes =
  | ISetHICustomer
  | IResetHICustomer
  | ISetHICustomerDetails
